import { createReducer, on } from '@ngrx/store';
import _ from 'lodash';
import {
    clearPrecheckin,
    getPrecheckin,
    savePrecheckin,
    updatePrecheckin,
} from './precheckin.actions';

export const savePrecheckinReducer = (_: any, { value }: { value: any }): any =>
    value;

export const getPrecheckinReducer = (data: any): any => data;

export const clearPrecheckinReducer = () => {
    return {};
};

export const updatePrecheckinReducer = (
    previus: any,
    { value }: { value: any },
): any => {
    return _.mergeWith({}, previus, value, (objValue, srcValue) => {
        if (Array.isArray(objValue)) {
            return srcValue;
        }
    });
};

export const PrecheckinReducer = createReducer(
    {},
    on(savePrecheckin, savePrecheckinReducer),
    on(updatePrecheckin, updatePrecheckinReducer),
    on(clearPrecheckin, clearPrecheckinReducer),
    on(getPrecheckin, getPrecheckinReducer),
);
